export enum PurchaseOrderProjectDestinationEnum {
  STORED = "STORED",
  CONSUMED = "CONSUMED",
}

export const getPurchaseOrderProjectDestinationLabel = (destination: PurchaseOrderProjectDestinationEnum): string => {
  switch (destination) {
    case PurchaseOrderProjectDestinationEnum.STORED:
      return "Se almacena";
    case PurchaseOrderProjectDestinationEnum.CONSUMED:
      return "Se consume";
  }
};

export const getPurchaseOrderProjectDestinationOptions = (): { label: string; value: string }[] => {
  return Object.values(PurchaseOrderProjectDestinationEnum).map((value) => ({
    label: getPurchaseOrderProjectDestinationLabel(value),
    value,
  }));
};
